import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import WhyChooseUs from "@/components/WhyChooseUs";
import Services from "@/components/Services";
import FeaturedProducts from "@/components/FeaturedProducts";
import Portfolio from "@/components/Portfolio";
import Testimonials from "@/components/Testimonials";
import QuoteForm from "@/components/QuoteForm";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <Stats />
      <WhyChooseUs />
      <Services />
      <FeaturedProducts />
      <Portfolio />
      <Testimonials />
      <QuoteForm />
      <FloatingWhatsApp />
    </>
  );
}
